export default (function(context,factory){

	return factory();

})(window,function(){

	/**
	 * @desc 配置文件
	 * @exports
	 * @version 1.0.0
	 * @author maixingjie
	 * @copyright Copyright 2014-2015
	 * 
	 */
	var qt_model={};

	//登陆
	qt_model.LOGIN_SCAN = "/base/pc/schadm/login/tokenAsk",  //登陆请求码

	qt_model.LOGIN_CONFIRM = "/base/pc/schadm/login/lgConfirm",  //扫码登陆确认

	qt_model.LOGIN_POLLING = '/base/pc/schadm/login/pollChk'; //获取登陆结果

	qt_model.LOGIN_SMSCODE = '/base/pc/schadm/login/codeAsk'; //获取短信验证码

	qt_model.LOGIN_BINDASK = '/base/pc/schadm/login/bindAsk'; //手机号码绑定

	//班级管理
	qt_model.CLAZZ_LIST = "/base/pc/schadm/clazz/list",  //班级列表

	qt_model.CLAZZ_CHANGE = '/base/pc/schadm/clazz/changeInSchManager'; //班级状态处理：是否管理
	
	qt_model.CLASS_ALL_LIST = '/base/pc/schadm/clazz/simpleList'; //获取班级

	//食谱的url
	qt_model.SP_DETIAL = '/notice/pc/schadm/recipe/detail'; //菜谱详情

	qt_model.SP_UPDATE = '/notice/pc/schadm/recipe/update'; //菜谱更新/修改

	qt_model.SP_DEL = '/notice/pc/schadm/recipe/del'; //菜谱删除

	qt_model.SP_STATE_CHANGE = '/notice/pc/schadm/recipe/change'; //菜谱状态改变

	//用户管理
	qt_model.USERS_LIST ='/base/pc/schadm/user/list';

	qt_model.USERS_ADD ='/base/pc/schadm/user/add';

	qt_model.USERS_DEL ='/base/pc/schadm/user/del';

	qt_model.USERS_MDF ='/base/pc/schadm/user/update';


	qt_model.TIWEN_LIST = '/notice/pc/schadm/tiwen/list'

	qt_model.TIWEN_UNUSUAL = '/notice/pc/schadm/tiwen/unusual'

	qt_model.TIWEN_EXPORT = '/notice/pc/schadm/tiwen/export'

	qt_model.LEAVE_LIST = '/notice/pc/schadm/leave/listV3'

	qt_model.LEAVE_EXPORT = '/notice/pc/schadm/leave/exportV3'
    
	qt_model.LEAVE_EXPORT_ALL_CLASS = '/notice/pc/schadm/leave/exportAllClass'



	return qt_model;
});



// WEBPACK FOOTER //
// ./src/js/api_url.js